/* eslint-disable */
import { BehaviorSubject, Subject, Observable } from "rxjs";
import { share } from "rxjs/operators";

export class ObservableFactory {
  public static createBehaviorSubject<T>(initializeValue: T, onUpdate?: (val : T) => void): [Observable<T>, (val : T) => void] {
    const stream$ = new BehaviorSubject<T>(initializeValue);
    return ObservableFactory._createObservable(stream$, onUpdate);
  }

  public static createSubject<T>(onUpdate?: (val : T) => void): [Observable<T>, (val : T) => void]{
    const stream$ = new Subject<T>();
    return ObservableFactory._createObservable(stream$, onUpdate);
  }

  protected static _createObservable<T>(stream$ : BehaviorSubject<T> | Subject<T>, onUpdate?: (val : T) => void): [Observable<T>, (val : T) => void] {
    const sharedStream$ = stream$;
    
    if (onUpdate) {
      sharedStream$.subscribe(value => {
        onUpdate(value);
      });
    }

    const next = (value: T) => stream$.next(value);
    return [sharedStream$, next];
  }
}